import { useContext, useRef, useState } from "react";
import { AppContext } from "../contexts/AppContext";
import { useForm } from "react-hook-form";
import {
  base_url,
  confirmPasswordValidation,
  errorResponseMessage,
  httpHeaderConfig,
  passwordValidation,
  togglePasswordVisibility,
} from "./const.prop";
import axios from "axios";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const appContext = useContext(AppContext);
  const passwordInp = useRef();
  const confirmPasswordInp = useRef();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
  });
  const { ref: passwordRef } = register("password");
  const { ref: confirmPasswordRef } = register("confirmPassword");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const submitHandler = async (data) => {
    if (data.password !== data.confirmPassword) {
      toast.error("Passwords not matching");
    } else {
      try {
        const submitData = await axios.post(
          `${base_url}verify-code`,
          {
            password: btoa(data.password),
            code: JSON.parse(localStorage.getItem("resetPasswordConfirm")).otp,
            userId: localStorage.getItem("userId"),
          },
          {
            headers: httpHeaderConfig,
          }
        );
        if (submitData.status === 201) {
          appContext.updateModalState();
          setTimeout(() => {
            appContext.updateModalType("resetSuccess");
          }, 200);
        }
      } catch (error) {
        if (error.response?.status >= 500) {
          appContext.updateNotificationState({
            show: true,
            message: "Something went wrong, please try again later.",
            type: "error",
          });
          appContext.updateModalType("resetSuccess");
          return;
        }
        appContext.updateNotificationState({
          show: true,
          type: "error",
          message: errorResponseMessage(error) + ".Please try again.",
        });
        appContext.updateModalType("resetSuccess");
      }
    }
  };
  const handlePasswordToggle = (isPassword = false) => {
    if (isPassword) {
      setShowPassword((prev) => !!!prev);
      togglePasswordVisibility(passwordInp);
    } else {
      setShowConfirmPassword((prev) => !!!prev);
      togglePasswordVisibility(confirmPasswordInp);
    }
  };
  return (
    <div className="modal-body px-5">
      <p className="modal-head">
        {/* <a
          onClick={(e) => {
            e.preventDefault();
            appContext.updateModalState();
          }}
          className="arrow mr-3"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <rect width="24" height="24" rx="4" fill="#F7F7F7" />
            <path
              d="M10.7384 17.7432L5.22953 12.0942C5.14607 12.0086 5.08681 11.9159 5.05175 11.816C5.01725 11.7162 5 11.6092 5 11.4951C5 11.3809 5.01725 11.274 5.05175 11.1741C5.08681 11.0742 5.14607 10.9815 5.22953 10.8959L10.7384 5.2469C10.8914 5.08998 11.0825 5.00781 11.3118 5.0004C11.5416 4.99355 11.74 5.07572 11.9069 5.2469C12.0738 5.40382 12.1609 5.59982 12.1682 5.83491C12.1748 6.07057 12.0947 6.27399 11.9278 6.44518L7.83788 10.6391H17.1653C17.4018 10.6391 17.6002 10.721 17.7604 10.8848C17.9201 11.0491 18 11.2526 18 11.4951C18 11.7376 17.9201 11.9407 17.7604 12.1045C17.6002 12.2688 17.4018 12.351 17.1653 12.351H7.83788L11.9278 16.5449C12.0808 16.7019 12.1609 16.9016 12.1682 17.1441C12.1748 17.3866 12.0947 17.5863 11.9278 17.7432C11.7747 17.9144 11.58 18 11.3435 18C11.107 18 10.9053 17.9144 10.7384 17.7432Z"
              fill="#565555"
            />
          </svg>
        </a> */}
        Create new password
      </p>
      <p>Enter new password.</p>
      <form onSubmit={handleSubmit(submitHandler)}>
        <div className="mb-3 mt-4">
          <label className="sign-label">New Password</label>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text sign-icon" id="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.76547 1.41792C10.8338 1.41792 12.5182 3.10234 12.5182 5.1728L12.5181 6.28956C13.7756 6.72717 14.6801 7.92425 14.6801 9.32916V12.3672C14.6801 14.1416 13.2373 15.5844 11.4629 15.5844H6.0505C4.27613 15.5844 2.83325 14.1416 2.83325 12.3672V9.32916C2.83325 7.92452 3.73745 6.72762 4.99452 6.2898L4.99501 5.1728C4.99926 4.1528 5.39381 3.21142 6.10568 2.50592C6.81826 1.79971 7.75893 1.39101 8.76547 1.41792ZM11.4629 7.17441H6.0505C4.86192 7.17441 3.89575 8.14057 3.89575 9.32916V12.3672C3.89575 13.5558 4.86192 14.5219 6.0505 14.5219H11.4629C12.6508 14.5219 13.6176 13.5558 13.6176 12.3672V9.32916C13.6176 8.14057 12.6508 7.17441 11.4629 7.17441ZM8.75655 9.53018C9.0498 9.53018 9.2878 9.76818 9.2878 10.0614V11.6346C9.2878 11.9279 9.0498 12.1659 8.75655 12.1659C8.4633 12.1659 8.2253 11.9279 8.2253 11.6346V10.0614C8.2253 9.76818 8.4633 9.53018 8.75655 9.53018ZM8.76335 2.48042H8.75201C8.03447 2.48042 7.36226 2.75667 6.85439 3.2603C6.34297 3.76605 6.06035 4.44109 6.05751 5.16076L6.05688 6.11151H11.4551L11.4557 5.1728C11.4557 3.68813 10.248 2.48042 8.76335 2.48042Z"
                    fill="black"
                    fillOpacity="0.6"
                  />
                </svg>
              </span>
            </div>
            <input
              type="password"
              className="form-control sign-form"
              {...register("password", passwordValidation)}
              ref={(e) => {
                passwordRef(e);
                passwordInp.current = e;
              }}
            />
            <div className="input-group-append">
              <span
                className="input-group-text sign-icon"
                onClick={() => handlePasswordToggle(true)}
              >
                {!showPassword && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_26_905)">
                      <path
                        d="M6.89331 4.78272L8.8974 6.78681L8.90694 6.68184C8.90694 5.62888 8.05124 4.77318 6.99829 4.77318L6.89331 4.78272Z"
                        fill="#ABABAB"
                      />
                      <path
                        d="M6.99843 3.50075C8.75439 3.50075 10.1795 4.9259 10.1795 6.68186C10.1795 7.09222 10.0968 7.4835 9.95369 7.84295L11.8146 9.70389C12.7753 8.90225 13.5324 7.86523 14 6.68186C12.8962 3.88887 10.1827 1.91022 6.99846 1.91022C6.10774 1.91022 5.25523 2.06926 4.46313 2.35556L5.83737 3.7266C6.19679 3.58664 6.58807 3.50075 6.99843 3.50075Z"
                        fill="#ABABAB"
                      />
                      <path
                        d="M0.636209 1.76711L2.08679 3.21769L2.37628 3.50718C1.32652 4.3279 0.496251 5.41903 0 6.6819C1.10067 9.4749 3.81731 11.4535 6.99842 11.4535C7.98457 11.4535 8.92616 11.2627 9.78825 10.9159L10.0587 11.1863L11.9132 13.0441L12.7244 12.2361L1.44739 0.955933L0.636209 1.76711ZM4.15452 5.28223L5.13748 6.26519C5.10885 6.40199 5.08976 6.53875 5.08976 6.6819C5.08976 7.73486 5.94547 8.59056 6.99842 8.59056C7.14157 8.59056 7.27837 8.57147 7.41197 8.54284L8.39493 9.5258C7.97183 9.73575 7.50105 9.86301 6.99842 9.86301C5.24245 9.86301 3.81731 8.43787 3.81731 6.6819C3.81731 6.1793 3.94457 5.70849 4.15452 5.28223Z"
                        fill="#ABABAB"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_26_905">
                        <rect width="14" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
                {showPassword && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                  >
                    <path
                      d="M15.4567 8.80458C15.3979 8.72029 13.9961 6.71925 12.0616 5.35146C11.0586 4.641 9.79353 4.25 8.50011 4.25C7.20741 4.25 5.94232 4.641 4.9372 5.35146C3.00274 6.71925 1.60236 8.72029 1.54357 8.80458C1.46116 8.92323 1.41699 9.06423 1.41699 9.20869C1.41699 9.35315 1.46116 9.49415 1.54357 9.61279C1.60236 9.69708 3.00274 11.6981 4.9372 13.0659C5.94232 13.7757 7.20741 14.1667 8.50011 14.1667C9.79353 14.1667 11.0586 13.7757 12.0616 13.0652C13.9961 11.6974 15.3979 9.69637 15.4567 9.61208C15.5393 9.49366 15.5836 9.35274 15.5836 9.20833C15.5836 9.06393 15.5393 8.923 15.4567 8.80458ZM8.50011 11.6875C7.1302 11.6875 6.02095 10.5754 6.02095 9.20833C6.02095 7.83842 7.1302 6.72917 8.50011 6.72917C9.8672 6.72917 10.9793 7.83842 10.9793 9.20833C10.9793 10.5754 9.8672 11.6875 8.50011 11.6875ZM9.91678 9.20833C9.91678 9.98892 9.2807 10.625 8.50011 10.625C8.21992 10.625 7.94603 10.5419 7.71306 10.3862C7.48009 10.2306 7.29851 10.0093 7.19129 9.75047C7.08406 9.49161 7.05601 9.20676 7.11067 8.93196C7.16533 8.65715 7.30026 8.40472 7.49838 8.2066C7.6965 8.00847 7.94893 7.87355 8.22374 7.81889C8.49854 7.76423 8.78339 7.79228 9.04225 7.8995C9.30111 8.00673 9.52236 8.18831 9.67803 8.42128C9.8337 8.65425 9.91678 8.92814 9.91678 9.20833Z"
                      fill="#ABABAB"
                    />
                  </svg>
                )}
              </span>
            </div>
          </div>
          <label className="sign-label mt-3">Confrim Password</label>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text sign-icon" id="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.76547 1.41792C10.8338 1.41792 12.5182 3.10234 12.5182 5.1728L12.5181 6.28956C13.7756 6.72717 14.6801 7.92425 14.6801 9.32916V12.3672C14.6801 14.1416 13.2373 15.5844 11.4629 15.5844H6.0505C4.27613 15.5844 2.83325 14.1416 2.83325 12.3672V9.32916C2.83325 7.92452 3.73745 6.72762 4.99452 6.2898L4.99501 5.1728C4.99926 4.1528 5.39381 3.21142 6.10568 2.50592C6.81826 1.79971 7.75893 1.39101 8.76547 1.41792ZM11.4629 7.17441H6.0505C4.86192 7.17441 3.89575 8.14057 3.89575 9.32916V12.3672C3.89575 13.5558 4.86192 14.5219 6.0505 14.5219H11.4629C12.6508 14.5219 13.6176 13.5558 13.6176 12.3672V9.32916C13.6176 8.14057 12.6508 7.17441 11.4629 7.17441ZM8.75655 9.53018C9.0498 9.53018 9.2878 9.76818 9.2878 10.0614V11.6346C9.2878 11.9279 9.0498 12.1659 8.75655 12.1659C8.4633 12.1659 8.2253 11.9279 8.2253 11.6346V10.0614C8.2253 9.76818 8.4633 9.53018 8.75655 9.53018ZM8.76335 2.48042H8.75201C8.03447 2.48042 7.36226 2.75667 6.85439 3.2603C6.34297 3.76605 6.06035 4.44109 6.05751 5.16076L6.05688 6.11151H11.4551L11.4557 5.1728C11.4557 3.68813 10.248 2.48042 8.76335 2.48042Z"
                    fill="black"
                    fillOpacity="0.6"
                  />
                </svg>
              </span>
            </div>
            <input
              type="password"
              className="form-control sign-form"
              {...register("confirmPassword", {
                passwordValidation,
                validate: (val) => {
                  confirmPasswordValidation(val, passwordInp.current.value);
                },
              })}
              ref={(e) => {
                confirmPasswordRef(e);
                confirmPasswordInp.current = e;
              }}
            />
            <div className="input-group-append">
              <span
                className="input-group-text sign-icon"
                onClick={() => handlePasswordToggle(false)}
              >
                {!showConfirmPassword && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_26_905)">
                      <path
                        d="M6.89331 4.78272L8.8974 6.78681L8.90694 6.68184C8.90694 5.62888 8.05124 4.77318 6.99829 4.77318L6.89331 4.78272Z"
                        fill="#ABABAB"
                      />
                      <path
                        d="M6.99843 3.50075C8.75439 3.50075 10.1795 4.9259 10.1795 6.68186C10.1795 7.09222 10.0968 7.4835 9.95369 7.84295L11.8146 9.70389C12.7753 8.90225 13.5324 7.86523 14 6.68186C12.8962 3.88887 10.1827 1.91022 6.99846 1.91022C6.10774 1.91022 5.25523 2.06926 4.46313 2.35556L5.83737 3.7266C6.19679 3.58664 6.58807 3.50075 6.99843 3.50075Z"
                        fill="#ABABAB"
                      />
                      <path
                        d="M0.636209 1.76711L2.08679 3.21769L2.37628 3.50718C1.32652 4.3279 0.496251 5.41903 0 6.6819C1.10067 9.4749 3.81731 11.4535 6.99842 11.4535C7.98457 11.4535 8.92616 11.2627 9.78825 10.9159L10.0587 11.1863L11.9132 13.0441L12.7244 12.2361L1.44739 0.955933L0.636209 1.76711ZM4.15452 5.28223L5.13748 6.26519C5.10885 6.40199 5.08976 6.53875 5.08976 6.6819C5.08976 7.73486 5.94547 8.59056 6.99842 8.59056C7.14157 8.59056 7.27837 8.57147 7.41197 8.54284L8.39493 9.5258C7.97183 9.73575 7.50105 9.86301 6.99842 9.86301C5.24245 9.86301 3.81731 8.43787 3.81731 6.6819C3.81731 6.1793 3.94457 5.70849 4.15452 5.28223Z"
                        fill="#ABABAB"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_26_905">
                        <rect width="14" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
                {showConfirmPassword && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                  >
                    <path
                      d="M15.4567 8.80458C15.3979 8.72029 13.9961 6.71925 12.0616 5.35146C11.0586 4.641 9.79353 4.25 8.50011 4.25C7.20741 4.25 5.94232 4.641 4.9372 5.35146C3.00274 6.71925 1.60236 8.72029 1.54357 8.80458C1.46116 8.92323 1.41699 9.06423 1.41699 9.20869C1.41699 9.35315 1.46116 9.49415 1.54357 9.61279C1.60236 9.69708 3.00274 11.6981 4.9372 13.0659C5.94232 13.7757 7.20741 14.1667 8.50011 14.1667C9.79353 14.1667 11.0586 13.7757 12.0616 13.0652C13.9961 11.6974 15.3979 9.69637 15.4567 9.61208C15.5393 9.49366 15.5836 9.35274 15.5836 9.20833C15.5836 9.06393 15.5393 8.923 15.4567 8.80458ZM8.50011 11.6875C7.1302 11.6875 6.02095 10.5754 6.02095 9.20833C6.02095 7.83842 7.1302 6.72917 8.50011 6.72917C9.8672 6.72917 10.9793 7.83842 10.9793 9.20833C10.9793 10.5754 9.8672 11.6875 8.50011 11.6875ZM9.91678 9.20833C9.91678 9.98892 9.2807 10.625 8.50011 10.625C8.21992 10.625 7.94603 10.5419 7.71306 10.3862C7.48009 10.2306 7.29851 10.0093 7.19129 9.75047C7.08406 9.49161 7.05601 9.20676 7.11067 8.93196C7.16533 8.65715 7.30026 8.40472 7.49838 8.2066C7.6965 8.00847 7.94893 7.87355 8.22374 7.81889C8.49854 7.76423 8.78339 7.79228 9.04225 7.8995C9.30111 8.00673 9.52236 8.18831 9.67803 8.42128C9.8337 8.65425 9.91678 8.92814 9.91678 9.20833Z"
                      fill="#ABABAB"
                    />
                  </svg>
                )}
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-md-1"></div>
            <div className="col-md-10 text-center">
              <button type="submit" className="btn btn-primary sign-btn mt-5">
                Continue
              </button>
            </div>
            <div className="col-md-1"></div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ResetPassword;
